import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const company = get(state, 'company.data.rows[0].name');
  const slug = get(state, 'company.data.rows[0].url');

  return baseSeoUtil({
    site,
    siteConf,
    title: `${company}: Articles, Info, Video | Fast Company`,
    url: `https://www.fastcompany.com/company/${slug}`,
    description: `Read more about ${company} on Fast Company`,
    image: `https://fast-company-res.cloudinary.com/image/upload/v1480632834/fast-company-share-graphic.png`,
    articleSection: 'Most Innovative Companies'
  });
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/company_page_seo_util.js